// RowHeader.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// Hooks
import {
    DEFAULT_CORNER_WIDTH,
    DEFAULT_OPEN_ONLY_CORNER_WIDTH,
} from 'views/table/hooks/useTableSettings';

// CSS
import './RowHeader.css';

// Components
import Checkbox from 'components/checkbox/Checkbox';
import RowHeaderButton from 'views/table/rowheader/button/RowHeaderButton';

/**
 * RowHeader
 * 
 * Renders the row header for a table.
 * 
 * @param {Function} onOpen - Callback when open button is clicked.
 *  
 *
 * @returns {ReactNode} - RowHeader.
 */
const RowHeader = React.memo(({
    onOpen,
    selected,
    onToggleSelect,
    showCheckboxes = true,
    isRowHovered = false,
}) => {

    // ----- CONTEXT ----- //

    // Theme Context

    const { theme } = useTheme();

    // ----- STATE ----- //

    const [hovered, setHovered] = useState(false);
    const showOpen = hovered || isRowHovered;

    // ----- RENDER ----- //

    return (

        <div
          className="row-header-container"
          style={{
            width: showCheckboxes ? DEFAULT_CORNER_WIDTH : DEFAULT_OPEN_ONLY_CORNER_WIDTH,
          }}
        >
            {/* DRAG 
            <RowHeaderButton
                iconKey="drag_indicator"
                onClick={onOpen}
            />
            */}

            {/* OPEN */}
            <div
              className="row-header-open"
              style={{
                    color: showOpen ? theme.foregroundMuted : 'transparent',
                }}
              onClick={onOpen}
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >

                <RowHeaderButton
                  iconKey="login"
                  title="Open"
                />

            </div>

            {/* CHECKBOX */}
            {showCheckboxes ? (
                <div
                  className="row-header-checkbox"
                >
                    <Checkbox
                      value={selected}
                      size="20"
                      onChange={onToggleSelect}
                    />
                </div>
            ) : null}

        </div>
    );

});

// Dev Tools
RowHeader.displayName = 'RowHeader';

export default RowHeader;
